import React from 'react';
export default App;

const accent = '#bfa16a'; // delikatny beżowy akcent
const main = '#FFFFFF';
const button = '#051428'; // granat


const KlubowiczBenefits = [
  'Zniżka na nasze wyjątkowe produkty do 15%',
  'Atrakcyjne promocje i oferty specjalne',
  'Dostęp do szkoleń i bazy wiedzy',
  'Możliwość udziału w Programach Motywacyjnych',
  'Możliwość zarabiania',
];

const KlientBenefits = [
  'Zniżka na nasze wyjątkowe produkty do 15%',
  'Atrakcyjne promocje i oferty specjalne',
];




function OptionCard({ title, subtitle, benefits, accentText, onClick, variant }) {
  // variant: 'klubowicz' | 'klient'
  // Klubowicz: gold check, Klient: gold check for 2, gray x for 3
  const klubowiczAllBenefits = [
    'Zniżka na nasze wyjątkowe produkty do 15% (Klient) / 30% (Klubowicz)',
    'Atrakcyjne promocje i oferty specjalne',
    'Dostęp do szkoleń i bazy wiedzy',
    'Możliwość udziału w Programach Motywacyjnych',
    'Możliwość zarabiania',
  ];
  return (
    <div className="option-card">
      <div className="option-card-header big-header">{title}</div>
      <div className="option-card-subtitle">{subtitle}</div>
      <ul className="option-card-benefits align-benefits">
        {klubowiczAllBenefits.map((b, i) => (
          <li key={i}>
            {variant === 'klubowicz' ? (
              <span className="gold-check">✔</span>
            ) : (
              i < 2 ? <span className="gold-check">✔</span> : <span className="gray-x">✖</span>
            )}
            <span className="benefit-text">{b}</span>
          </li>
        ))}
      </ul>
      <div className="option-card-desc">
        {variant === 'klubowicz' ? (
          <p className="option-card-desc-text">
            Klubowicz DUOLIFE to osoba, która nie tylko korzysta z najlepszych cen i promocji, ale także może budować własną strukturę, rozwijać się i zarabiać.<br/><br/>
            Otrzymujesz dostęp do szkoleń, wiedzy i wyjątkowych programów motywacyjnych. To idealna opcja, jeśli chcesz polecać produkty innym i korzystać z pełni benefitów!
          </p>
        ) : (
          <p className="option-card-desc-text">
            Klient Preferowany DUOLIFE to opcja dla osób, które chcą po prostu kupować produkty na własny użytek i korzystać z atrakcyjnych promocji – bez budowania struktury i dodatkowych zobowiązań.<br/><br/>
            Wybierz tę opcję, jeśli zależy Ci na prostych zakupach i rabatach!
          </p>
        )}
      </div>
      <div className="option-card-btn-row">
        <button className="option-card-btn" onClick={onClick}>Zarejestruj się</button>
      </div>
    </div>
  );
}
function App() {
  return (
    <div>
      <style>{`
        @font-face {
          font-family: 'SF Pro Display';
          src: url('/fonts/SF-Pro.ttf') format('truetype');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }
        .split-layout {
          display: flex;
          min-height: 100vh;
          background: #f7f8fa;
          max-width: 100vw;
          overflow-x: hidden;
        }
        .side-info {
          flex: 1 1 0;
          max-width: 420px;
          min-width: 320px;
          width: 100%;
          background: ${button};
          color: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 32px 18px 20px 18px;
          box-shadow: 8px 0 32px 0 #05142818;
          box-sizing: border-box;
          word-break: break-word;
        }
        .side-brand {
          font-size: 2.9rem;
          font-weight: 900;
          letter-spacing: 1px;
          margin-bottom: 0.1em;
          font-family: 'SF Pro Display', Arial, sans-serif;
          color: ${accent};
        }
        .side-brand-gold {
          color: ${accent};
          font-weight: 900;
        }
        .side-author {
          font-size: 1.55rem;
          color: #fff;
          margin-bottom: 1.8em;
        }
        .side-desc {
          margin-bottom: 2em;
        }
        .side-desc h2 {
          font-size: 1.35rem;
          margin-bottom: 0.7em;
          color: #fff;
          font-weight: 700;
        }
        .side-desc-main {
          font-size: 1.09rem;
          color: #fff;
          margin-bottom: 1.2em;
          line-height: 1.5;
          word-break: break-word;
        }
        .side-desc-secondary {
          font-size: 1.01rem;
          color: #fff;
          margin-bottom: 0.5em;
          line-height: 1.5;
          word-break: break-word;
        }
        .side-contact {
          margin-top: auto;
          font-size: 1.35rem;
          color: #fff;
          font-weight: 700;
          letter-spacing: 0.5px;
          align-self: flex-start;
          text-align: left;
        }
        .contact-title, .contact-phone {
          text-align: left;
        }
        .side-contact a {
          color: #fff;
          text-decoration: none;
        }
        .contact-title {
                   <div className="contact-phone">
                     <span className="gold-phone" style={{
                       filter: 'brightness(0) saturate(100%) sepia(1) hue-rotate(30deg) saturate(6) brightness(1.2)',
                       display: 'inline-block',
                       marginRight: '4px',
                       verticalAlign: 'middle',
                     }}>📞</span> +48 692 210 739
                   </div>
          font-weight: 900;
          margin-bottom: 0.3em;
        }
        .contact-phone {
          font-size: 1.22rem;
          margin-bottom: 0.2em;
        }
        .main-cards-wide {
          flex: 2 1 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 32px 0 24px 0;
        }
        .main-title {
          font-size: 2rem;
          color: ${button};
          font-weight: 700;
          margin-bottom: 24px;
          text-align: center;
          font-family: 'SF Pro Display', Arial, sans-serif;
        }
        .existing-users-section {
          margin-bottom: 32px;
          text-align: center;
          padding: 24px 20px;
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 4px 16px 0 #05142812;
          max-width: 600px;
          width: 100%;
        }
        .existing-users-title {
          font-size: 1.4rem;
          color: ${button};
          font-weight: 700;
          margin-bottom: 20px;
          font-family: 'SF Pro Display', Arial, sans-serif;
        }
        .existing-users-buttons {
          display: flex;
          gap: 24px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .existing-user-btn {
          background: ${accent};
          color: ${button};
          border: none;
          border-radius: 12px;
          padding: 14px 32px;
          font-size: 1.1rem;
          font-weight: 700;
          font-family: 'SF Pro Display', Arial, sans-serif;
          cursor: pointer;
          box-shadow: 0 2px 12px 0 #BFA16A22;
          transition: all 0.18s ease;
          min-width: 180px;
        }
        .existing-user-btn:hover {
          background: ${button};
          color: #fff;
          box-shadow: 0 4px 24px 0 #05142855;
          transform: translateY(-2px);
        }
        .shop-note-inline {
          display: block;
          font-size: 0.8rem;
          font-weight: 400;
          margin-top: 2px;
          opacity: 0.8;
        }
        .registration-section {
          margin-bottom: 24px;
          text-align: center;
        }
        .registration-title {
          font-size: 1.4rem;
          color: ${button};
          font-weight: 600;
          margin-bottom: 0;
          font-family: 'SF Pro Display', Arial, sans-serif;
        }
        .cards-row-wide {
          display: flex;
          flex-direction: row;
          gap: 36px;
          justify-content: center;
          align-items: stretch;
          width: 100%;
          max-width: 900px;
        }
        .option-card {
          background: #fff;
          border-radius: 22px;
          box-shadow: 0 8px 32px 0 #05142818;
          padding: 42px 32px 42px 32px;
          min-width: 0;
          width: 100%;
          max-width: 520px;
          min-height: 520px;
          flex: 1 1 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: box-shadow 0.25s, transform 0.18s;
          border: 2px solid #e5e5e5;
          justify-content: flex-start;
        }
        .option-card-desc {
          width: 100%;
          flex: 1 1 auto;
          display: flex;
          align-items: flex-end;
        }
        .option-card-desc-text {
          margin-top: 16px;
          margin-bottom: 0;
          color: #444;
          font-size: 1.05rem;
          text-align: center;
          width: 100%;
        }
        .option-card-btn-row {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin-top: 24px;
        }
        .option-card-benefits li {
          font-size: 1.05rem;
          color: ${button};
          margin-bottom: 12px;
          font-family: 'SF Pro Display', Arial, sans-serif;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .gold-check {
          color: ${accent};
          font-size: 1.2em;
          font-weight: bold;
          margin-right: 6px;
          filter: drop-shadow(0 0 2px #FFD70099);
        }
        .gray-x {
          color: #b0b0b0;
          font-size: 1.2em;
          font-weight: bold;
          margin-right: 6px;
          filter: none;
        }
        .option-card-btn {
          background: ${button};
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 14px 36px;
          font-size: 1.1rem;
          font-weight: 700;
          font-family: 'SF Pro Display', Arial, sans-serif;
          cursor: pointer;
          box-shadow: 0 2px 12px 0 #05142822;
          transition: background 0.18s, box-shadow 0.18s, transform 0.18s;
        }
        .option-card-btn:hover {
          background: ${accent};
          color: ${button};
          box-shadow: 0 4px 24px 0 #FFD70055;
          transform: scale(1.06);
        }
        @media (max-width: 1100px) {
          .split-layout {
            flex-direction: column;
          }
          .side-info {
            max-width: 100vw;
            min-width: 0;
            width: 100vw;
            box-shadow: none;
            align-items: center;
            text-align: center;
            padding: 24px 6vw 20px 6vw;
          }
          .main-cards-wide {
            padding: 20px 4vw 16px 4vw;
          }
        }
        @media (max-width: 900px) {
          .cards-row-wide {
            flex-direction: column;
            gap: 20px;
            align-items: center;
          }
          .option-card {
            min-width: 0;
            max-width: 92vw;
            margin: 0 4vw;
          }
          .existing-users-section {
            max-width: 92vw;
            padding: 20px 4vw;
            margin: 0 4vw 24px 4vw;
          }
          .existing-users-buttons {
            flex-direction: column;
            gap: 14px;
            align-items: center;
          }
          .existing-user-btn {
            min-width: 200px;
            width: 100%;
            max-width: 280px;
          }
        }
        body {
          background: #f7f8fa;
        }
      .option-card-header.big-header {
        font-size: 1.35rem;
        font-weight: 700;
        margin-bottom: 0.7em;
        text-align: center;
        letter-spacing: 0.01em;
      }
      .option-card-benefits.align-benefits {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        min-height: 180px;
        margin-bottom: 16px;
      }
      .option-card-benefits.align-benefits li {
        min-height: 32px;
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
      }
      .benefit-text {
        display: inline-block;
        min-width: 260px;
        font-size: 1.08rem;
      }
      `}</style>
      <div className="split-layout">
        <aside className="side-info">
          <div className="side-brand">Myluxlife</div>
          <div className="side-author">Magdalena Ptasinska</div>
          <div className="side-desc">
            <h2>Witaj w <span className="side-brand-gold">MyLuxLife</span>!</h2>
            <p className="side-desc-main">
              To miejsce, gdzie możesz dołączyć do Klubu DUOLIFE lub zostać Klientem Preferowanym i korzystać z wyjątkowych promocji, szkoleń oraz możliwości rozwoju i zarabiania.
            </p>
            <p className="side-desc-secondary">
              Wybierz odpowiednią opcję, aby rozpocząć swoją przygodę z marką DUOLIFE.<br/>Masz pytania lub chcesz dowiedzieć się więcej? Skontaktuj się z nami!
            </p>
          </div>
          <div className="side-contact">
            <div className="contact-title">Kontakt</div>
             <div className="contact-phone">+48 692 210 739</div>
          </div>
        </aside>
        <main className="main-cards main-cards-wide">
          <h1 className="main-title">Wybierz odpowiednią opcję dla siebie</h1>
          
          <div className="existing-users-section">
            <h2 className="existing-users-title">Masz już konto?</h2>
            <div className="existing-users-buttons">
              <button 
                className="existing-user-btn login-btn"
                onClick={() => { window.location.href = 'https://oauth.myduolife.com/pl/auth/login'; }}
              >
                Zaloguj się
              </button>
              <button 
                className="existing-user-btn shop-btn"
                onClick={() => { window.location.href = 'https://magdalenaptasinska.myduolife.com/s'; }}
              >
                Przejdź do sklepu
                <span className="shop-note-inline">*bez zniżki</span>
              </button>
            </div>
          </div>

          <div className="registration-section">
            <h2 className="registration-title">Nie masz jeszcze konta? Zarejestruj się!</h2>
          </div>

          <div className="cards-row cards-row-wide">
            <OptionCard
              title="Zostań Klientem Preferowanym"
              subtitle="Kupuj na własne potrzeby i korzystaj z promocji!"
              accentText="Rabaty do 15%"
              variant="klient"
              onClick={() => { window.location.href = 'https://magdalenaptasinska.myduolife.com/register/client'; }}
            />
            <OptionCard
              title="Zostań Klubowiczem"
              subtitle="Kupuj, polecaj i korzystaj z pełni benefitów!"
              accentText="Rabaty do 30%"
              variant="klubowicz"
              onClick={() => { window.location.href = 'https://magdalenaptasinska.myduolife.com/register/club'; }}
            />
          </div>
        </main>
      </div>
    </div>
  );
}
